import { FC } from 'react';
import styled from 'styled-components';

import { remify } from '#/service/utils';

import { FooterLink } from './FooterLink';
import Logo from './Logo';
import { FooterContentProps } from './types';

const Container = styled.div`
  padding: 0 ${remify(50)};
  display: flex;
`;

const ColumnsContainer = styled.div`
  display: inline-block;
  width: 100%;
`;

const LogoContainer = styled.div`
  display: inline-block;
  min-width: 268px;
  max-width: 268px;
`;

const Columns = styled.div`
  display: grid;
  grid-auto-flow: column;
`;

const Column = styled.div`
  margin-right: ${remify(32)};
  margin-bottom: ${remify(44)};
`;

const ColumnTitle = styled.div`
  font: var(--fontStyleTitle);
  margin-bottom: ${remify(2)};
  overflow: hidden;
  display: block;
`;

const FooterColumns: FC<FooterContentProps> = ({ columns }) => {
  return (
    <Container>
      <LogoContainer>
        <Logo />
      </LogoContainer>

      <ColumnsContainer>
        <Columns>
          {columns.map(({ key, title, items }) => (
            <Column key={key}>
              <ColumnTitle>{title}</ColumnTitle>
              {items.map(({ key, ...rest }) => (
                <FooterLink key={key} {...rest} />
              ))}
            </Column>
          ))}
        </Columns>
      </ColumnsContainer>
    </Container>
  );
};

export default FooterColumns;
